import React from 'react';
import { FiCpu } from 'react-icons/fi';

export const LandingNavbar = ({ onLogin }) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-6 py-4 md:px-12 bg-slate-950/50 backdrop-blur-lg border-b border-white/5">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center shadow-[0_0_20px_rgba(37,99,235,0.4)]">
          <FiCpu className="text-white text-2xl" />
        </div>
        <span className="text-2xl font-black tracking-tighter text-white">ADAM<span className="text-blue-500">AI</span></span>
      </div>
      
      <div className="hidden md:flex items-center gap-8">
        <a href="#tech" className="text-sm font-medium text-slate-400 hover:text-white transition-colors">Technology</a>
        <a href="#academy" className="text-sm font-medium text-slate-400 hover:text-white transition-colors">Academy</a>
        <a href="#field" className="text-sm font-medium text-slate-400 hover:text-white transition-colors">Field Assist</a>
      </div>

      <button 
        onClick={onLogin}
        className="px-6 py-2 rounded-full bg-blue-600 hover:bg-blue-500 text-white font-bold text-sm transition-all hover:scale-105 active:scale-95 shadow-[0_0_15px_rgba(37,99,235,0.3)]"
      >
        LOGIN
      </button>
    </nav>
  );
};